<template>
  <div class="container-fluid py-3">
    <div v-if="inProgress || failed" class="col-sm-12">
      <div class="card text-center">
        <div class="card-body">
          <BeatLoader v-if="inProgress" />
          <i v-if="failed" class="fas fa-minus-circle fa-3x text-danger mt-3 p-3" />

          <div class="card-text">
            <p v-if="inProgress" v-html="message || $t('Upload.uploading')" />
            <p v-if="failed" v-html="message || $t('Upload.problem')" />

            <div
              class="progress w-100"
              v-if="inProgress"
              role="progressbar"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                :style="{ width: `${progress}%` }"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messages from 'locales/Upload';
import { mapState } from 'vuex';
import BeatLoader from 'components/shared/BeatLoader.vue';

export default {
  name: 'ProjectUploadProgress',
  components: { BeatLoader },
  computed: {
    ...mapState(['inProgress', 'failed', 'message', 'progress']),
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>

</style>
